/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

import { Component, createRef } from 'react';
import { WonAndNotWonDatatable } from 'shared/won-and-not-won-datatable/WonAndNotWonDatatable';
import { connect } from 'react-redux';
import { convertToMaintainData, getMaintainData, won } from 'shared/settings/stateMaintain';

import './Won.scss';
import store from 'features/store';

/**


@Author Karthik

@param

@return html page for won screen

**/

class Won extends Component {

    constructor(props) {
        super(props);
        this.maintainKey = `${won}${this.props.history.location.pathname}`;
        this.scrollRef = createRef();

        this.state = {
            noData: true,
            deleteItemsList: {},
            scrollTo: 0,
            isVisible: false,
            pageClientWidth: 16
        }
    }

    componentDidMount() {
        document.addEventListener('resize', this.resize)
    }

    getItemsList = (event) => {
        this.setState({
            noData: event.length === 0
        }, () => {
            if (event.scrollPage) {
                this.getPreviousValues();
            } else {
                store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "Won" } });
            }
        });
    }

    getPreviousValues = () => {
        const previous = getMaintainData(this.maintainKey);
        if (previous) {
            this.setState({
                ...this.state,
                ...previous,
            }, () => {
                this.scrollToPrevious();
                store.dispatch({ type: 'SET_PREVIOUS_PATH', payload: { component: "Won" } });
            });
        }
    }

    scrollToPrevious = () => {
        this.scrollRef.current.scrollTo({ top: this.state.scrollTo || 0, left: 0 });
    }

    handleScroll = (event) => {
        try {
            const scrollTop = event?.target?.scrollTop;
            if (scrollTop) {
                this.setState({
                    scrollTo: scrollTop,
                    pageClientWidth: this.scrollRef?.current?.clientWidth,
                    isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                });
            } else {
                this.setState({
                    pageClientWidth: this.scrollRef?.current?.clientWidth,
                    isVisible: (event.target.scrollHeight / 4) < event.target.scrollTop,
                })
            }
        } catch (error) {

        }
    }

    deleteItemsList = (event) => {
        this.setState({
            deleteItemsList: event
        });
    }

    scrollToTop = () => {
        this.scrollRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }

    resize = () => {
        this.setState({
            pageClientWidth: this.scrollRef?.current?.clientWidth,
        });
    }

    stateMaintenance = () => {
        const data = {
            scrollTo: this.state.scrollTo
        };
        convertToMaintainData(this.maintainKey, data);
    }
    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    render() {
        return (
            <div className="won-page" ref={this.scrollRef} onScroll={this.handleScroll} style={{ ...this.props.style }}>
                {
                    this.state.isVisible ?
                        <div className="scroll-top d-flex align-items-center justify-content-center clickable" style={{ right: `${window.innerWidth - this.state.pageClientWidth}px` }} onClick={this.scrollToTop}>
                            <i className="fas fa-arrow-up"></i>
                        </div> : null
                }
                <div className="datatable h-100">
                    <div className={`d-flex ${this.state.noData ? 'align-items-center h-100' : 'align-items-start'} justify-content-center`}>
                        <div className="large-screen-width">
                            <WonAndNotWonDatatable page={"won"}{...this.props} getItemsList={this.getItemsList} deleteItemsList={this.deleteItemsList}
                                stateMaintenance={this.stateMaintenance}></WonAndNotWonDatatable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => state)(Won);